import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=8162252e&scoped=true&"
import script from "./Recap.ts?vue&type=script&lang=ts&"
export * from "./Recap.ts?vue&type=script&lang=ts&"
import style0 from "./Recap.scss?vue&type=style&index=0&id=8162252e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8162252e",
  null
  
)

export default component.exports